// extracted by mini-css-extract-plugin
module.exports = {"container":"PaypalButton_container__lHOjy","dummyPaypalButton":"PaypalButton_dummyPaypalButton__UqJw9","errorMessage":"PaypalButton_errorMessage__3wApj"};